import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col, Navbar, Nav, NavItem, Tabs, Tab, Well } from 'react-bootstrap';
import logo from './logo.png';

import AboutUs from './components/common/AboutUs';
import FAQ from './components/common/FAQ';

import { OpenAQDataViewer } from './models/source/air';
import GovernancePane from './components/governance/Pane';
import WasteDataPane from './components/waste/Pane';
import LeafletMap from './components/maps/LeafletMap';

import ThingSpeakSource from './models/source/thingSpeak';

class App extends Component {
  constructor() {
    super();
    this.state = {
      showModals: {
        aboutUs: false,
        faq: false,
        contribute: false,
        contactUs: false,
        login: false
      }
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.printAppState = this.printAppState.bind(this);
  }
  componentDidMount() {
    let source = new ThingSpeakSource({
      url: process.env["REACT_APP_THINGSPEAK_URL"]
    });
    ThingSpeakSource.register(source);
    source.fetchChannels();
    this.props.governanceData.initialize();
    this.props.openAQ.source.initialize();
  }
  showModal(event) {
    let showModals = this.state.showModals;
    if(event.target.id) {
      (Object.keys(showModals)).map((key) => {
        showModals[key] = false;
      });
      showModals[event.target.id] = true;
      this.setState({
        showModals: showModals
      });
    }
  }
  closeModal() {
    let showModals = this.state.showModals;
    (Object.keys(showModals)).map((key) => {
      showModals[key] = false;
    });
    this.setState({
      showModals: showModals
    });
  }
  printAppState() {
  }
  render() {
    return (
      <div className="box">
        <Navbar className="row header" default collapseOnSelect>
          <Navbar.Header>
            <Navbar.Brand>
              <img src={logo}/>
            </Navbar.Brand>
            <Navbar.Brand>
              Neighbourhood Dashboard
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav pullRight>
              <NavItem eventKey={1} id="aboutUs" onClick={this.showModal}>
                About Us
              </NavItem>
              <NavItem eventKey={2} id="faq" onClick={this.showModal}>
                FAQ
              </NavItem>
              <NavItem eventKey={3} id="contribute" onClick={this.showModal}>
                Contribute
              </NavItem>
              <NavItem eventKey={4} id="contactUs" onClick={this.showModal}>
                Contact Us
              </NavItem>
              <NavItem eventKey={5} id="login" onClick={this.showModal}>
                Login
              </NavItem>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <Grid className="row content" bsClass="container-fluid">
          <Row className="show-grid">
            <Col xs={12} sm={6} md={8} lg={8}>
              <Well>
                <LeafletMap/>
              </Well>
            </Col>
            <Col xs={12} sm={6} md={4} lg={4}>
              <Well className="sidepane">
                <GovernancePane />
                <Tabs defaultActiveKey={1} id="data-selector-tab">
                  <Tab eventKey={1} title="Air">
                    <Well>
                      <OpenAQDataViewer />
                    </Well>
                  </Tab>
                  <Tab eventKey={2} title="Waste">
                    <WasteDataPane/>
                  </Tab>
                  <Tab eventKey={3} title="Water">
                    <Well>
                      Tab 3 content
                    </Well>
                  </Tab>
                  <Tab eventKey={4} title="Pothole">
                    <Well>
                      Tab 4 content
                    </Well>
                  </Tab>
                </Tabs>
              </Well>
            </Col>
          </Row>
        </Grid>
        <div className="static-modal">
          <AboutUs show={this.state.showModals.aboutUs} handleClose={this.closeModal}/>
          <FAQ show={this.state.showModals.faq} handleClose={this.closeModal}/>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return ({
    thingSpeak: state.thingSpeak,
    governanceData: state.governanceData,
    openAQ: state.openAQ
  });
}

export default connect(mapStateToProps)(App);
// export default App;



// WEBPACK FOOTER //
// ./src/App.js